<template>
	<span
		class="tooltip-container"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
	>
		<div
			v-if="$slots['btnSlot'] != undefined"
			class="tooltip-container__container"
			ref="icon"
		>
			<slot name="btnSlot" />
		</div>
		<i
			v-else
			:class="['icon', iconClassName, 'tooltip-container__icon']"
			ref="icon"
		/>

		<Tooltip
			class="tooltip-container__tooltip"
			trackedRefName="icon"
			:visible="tooltipVisible"
			:placement="placement"
			positionStrategy="fixed"
			:state="state"
			:offset="[0, 8]"
			@mouseenter.native="onTooltipEnter"
			@mouseleave.native="onTooltipLeave"
		>
			<template v-slot:default>
				<slot name="default">
					{{ tooltip }}
				</slot>
			</template>
		</Tooltip>
	</span>
</template>

<script>
import Tooltip from '@/components/shells/tooltip/tooltip.vue';
import componentStateMixin from '@/mixins/component-state-mixin';

export default {
	name: 'TooltipContainer',
	mixins: [componentStateMixin],
	components: {
		Tooltip
	},
	data() {
		return {
			tooltipVisible: false,
			hideTimeout: null
		};
	},
	props: {
		iconClassName: {
			type: String,
			default: 'icon-info'
		},
		tooltip: {
			type: String
		},
		tooltipEnabled: {
			type: Boolean,
			default: true
		},
		placement: {
			type: String,
			default: 'auto'
		}
	},
	methods: {
		onMouseEnter() {
			if (this.hideTimeout) clearTimeout(this.hideTimeout);
			this.tooltipVisible =
				this.tooltipEnabled &&
				(this.tooltip?.length > 0 || this.$slots.default?.length > 0);
		},
		onMouseLeave() {
			if (this.hideTimeout) clearTimeout(this.hideTimeout);
			this.hideTimeout = setTimeout(() => {
				this.tooltipVisible = false;
				this.hideTimeout = null;
			}, 100);
		},
		onTooltipEnter() {
			if (this.hideTimeout) clearTimeout(this.hideTimeout);
			this.tooltipVisible = true;
		},
		onTooltipLeave() {
			this.onMouseLeave();
		}
	},
	beforeDestroy() {
		if (this.hideTimeout) clearTimeout(this.hideTimeout);
	}
};
</script>

<style lang="scss" scoped>
.tooltip-container {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: relative;

	&__icon {
		font-size: min(100%, 18px);
		&:hover,
		&:focus,
		&:active {
			&:after {
				position: absolute;
				content: '';
				bottom: -$gutter-sm;
				left: 0;
				right: 0;
				border-bottom: 1px solid var(--brand-2);
			}
		}
	}
}

/* Tweak for Size in Tables */
.table {
	& .tooltip-container {
		&__icon {
			font-size: $table-icon-font-size;
		}
	}
}
</style>
